import { ActualityHqDataColumn } from '@warebee/shared/dataset-queries';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { DataTableState } from '../../common/types';
import {
  actualityHqTableData,
  actualityHqTableDataState,
} from '../store/actuality.hq.state';

function useShowFilteredActualityHqTable() {
  const setTableState = useSetRecoilState(actualityHqTableDataState);
  const resetTableData = useResetRecoilState(actualityHqTableData);

  return (state: DataTableState<ActualityHqDataColumn>) => {
    resetTableData();
    setTableState(state);
  };
}

export default useShowFilteredActualityHqTable;
